import React from 'react';
import { Image } from '@chakra-ui/core';
import LogoSrc from '../assets/images/logo@2x.png';

export const Logo = ({ alt = 'BelAvie', ...props }) => {
  return <Image src={LogoSrc} alt={alt} ignoreFallback {...props} />;
};
